import {
  CC_MODERATION_USER_JOINED,
  CC_STATUS_CHANGED,
  CC_MODERATION_USER_LEFT
} from "../actions/types/ccModeration";

const initialState = {
  ccModerationParticipants: [],
};

const ccModeration = (state = initialState, action) => {
  switch (action.type) {
    case CC_STATUS_CHANGED:
    case CC_MODERATION_USER_JOINED: {
      const objArray = state.ccModerationParticipants;
      const index = objArray.findIndex(
        (particpant) => particpant.particpantId === action.payload.particpantId
      );
      if (index !== -1) {
        objArray[index] = action.payload;
      } else {
        objArray.push(action.payload);
      }
      return {
        ...state,
        ccModerationParticipants: [...objArray],
      };
    }
    case CC_MODERATION_USER_LEFT: {
      const objArray = state.ccModerationParticipants;
      const filteredArray = objArray.filter(
        (particpant) => particpant.particpantId !== action.payload
      );
      
      return {
        ...state,
        ccModerationParticipants: [...filteredArray],
      };
    }
    default:
      return state;
  }
};

export default ccModeration;
